import config from "../config";

export default {
  get(name) {
    return config[name];
  },
};
